module.exports = __webpack_public_path__ + "ff8d31454c6276e8e776bda6744aa83a.svg";